// Deriva el seller desde el email de login y lo matchea contra las opciones de
// SELLERS_API. El email tiene el formato `nombre.inicialApellido@dominio`
// (ej. "tomas.r@..."), así que buscamos el seller cuyo primer nombre coincida y
// cuyo apellido empiece con esa inicial (ej. "Tomas Raptopulos").

// Saca acentos y pasa a minúsculas para comparar de forma robusta.
const norm = (s) =>
  (s || "")
    .normalize("NFD")
    .replace(/[̀-ͯ]/g, "")
    .toLowerCase()
    .trim();

export function matchSellerFromEmail(email, sellers) {
  if (!email || !Array.isArray(sellers) || sellers.length === 0) return null;

  const local = email.split("@")[0]; // "tomas.r"
  const [firstRaw, lastInitialRaw] = local.split(".");
  const first = norm(firstRaw);
  if (!first) return null;
  const lastInitial = lastInitialRaw ? norm(lastInitialRaw)[0] : null;

  return (
    sellers.find((name) => {
      const parts = norm(name).split(/\s+/).filter(Boolean); // ["tomas","raptopulos"]
      if (!parts.length || parts[0] !== first) return false;
      if (!lastInitial) return true;
      return parts.slice(1).some((p) => p[0] === lastInitial);
    }) || null
  );
}
